
import { WorldCity } from '../types';

// Expansión de Turquía - 75 ciudades principales
export const turkeyAdditionalCities: WorldCity[] = [
  { name: 'Istanbul', slug: 'istanbul', population: 15519267 },
  { name: 'Ankara', slug: 'ankara', population: 5663322 },
  { name: 'Izmir', slug: 'izmir', population: 2965900 },
  { name: 'Bursa', slug: 'bursa', population: 2842547 },
  { name: 'Adana', slug: 'adana', population: 2274106 },
  { name: 'Gaziantep', slug: 'gaziantep', population: 2069364 },
  { name: 'Konya', slug: 'konya', population: 2205609 },
  { name: 'Antalya', slug: 'antalya', population: 2548308 },
  { name: 'Kayseri', slug: 'kayseri', population: 1421362 },
  { name: 'Mersin', slug: 'mersin', population: 1868757 },
  { name: 'Eskişehir', slug: 'eskisehir', population: 888828 },
  { name: 'Diyarbakır', slug: 'diyarbakir', population: 1783431 },
  { name: 'Samsun', slug: 'samsun', population: 1348542 },
  { name: 'Denizli', slug: 'denizli', population: 1037208 },
  { name: 'Şanlıurfa', slug: 'sanliurfa', population: 2115256 },
  { name: 'Adapazarı', slug: 'adapazari', population: 1029650 },
  { name: 'Malatya', slug: 'malatya', population: 797036 },
  { name: 'Kahramanmaraş', slug: 'kahramanmaras', population: 1168163 },
  { name: 'Erzurum', slug: 'erzurum', population: 762321 },
  { name: 'Van', slug: 'van', population: 1136757 },
  { name: 'Batman', slug: 'batman', population: 608659 },
  { name: 'Elazığ', slug: 'elazig', population: 591098 },
  { name: 'İzmit', slug: 'izmit', population: 376056 },
  { name: 'Manisa', slug: 'manisa', population: 1440611 },
  { name: 'Sivas', slug: 'sivas', population: 646608 },
  { name: 'Gebze', slug: 'gebze', population: 400986 },
  { name: 'Balıkesir', slug: 'balikesir', population: 1228620 },
  { name: 'Tarsus', slug: 'tarsus', population: 245321 },
  { name: 'Çorum', slug: 'corum', population: 245266 },
  { name: 'Ordu', slug: 'ordu', population: 771932 },
  { name: 'Kırıkkale', slug: 'kirikkale', population: 280234 },
  { name: 'Afyonkarahisar', slug: 'afyonkarahisar', population: 251799 },
  { name: 'Isparta', slug: 'isparta', population: 441412 },
  { name: 'İnegöl', slug: 'inegol', population: 287908 },
  { name: 'Tekirdağ', slug: 'tekirdag', population: 1055412 },
  { name: 'Çanakkale', slug: 'canakkale', population: 540662 },
  { name: 'Giresun', slug: 'giresun', population: 448721 },
  { name: 'İskenderun', slug: 'iskenderun', population: 247333 },
  { name: 'Uşak', slug: 'usak', population: 367514 },
  { name: 'Düzce', slug: 'duzce', population: 405565 },
  { name: 'Osmaniye', slug: 'osmaniye', population: 559405 },
  { name: 'Çorlu', slug: 'corlu', population: 272892 },
  { name: 'Bandırma', slug: 'bandirma', population: 164965 },
  { name: 'Kızıltepe', slug: 'kiziltepe', population: 124215 },
  { name: 'Körfez', slug: 'korfez', population: 151628 },
  { name: 'Ayvalık', slug: 'ayvalik', population: 70899 },
  { name: 'Didim', slug: 'didim', population: 94221 },
  { name: 'Kuşadası', slug: 'kusadasi', population: 131226 },
  { name: 'Bodrum', slug: 'bodrum', population: 175363 },
  { name: 'Fethiye', slug: 'fethiye', population: 162686 },
  { name: 'Kaş', slug: 'kas', population: 56597 },
  { name: 'Kalkan', slug: 'kalkan', population: 4378 },
  { name: 'Göreme', slug: 'goreme', population: 2000 },
  { name: 'Ürgüp', slug: 'urgup', population: 18259 },
  { name: 'Avanos', slug: 'avanos', population: 35145 },
  { name: 'Nevşehir', slug: 'nevsehir', population: 298339 },
  { name: 'Aksaray', slug: 'aksaray', population: 422981 },
  { name: 'Niğde', slug: 'nigde', population: 364707 },
  { name: 'Karaman', slug: 'karaman', population: 253279 },
  { name: 'Ereğli', slug: 'eregli', population: 175123 },
  { name: 'Develi', slug: 'develi', population: 66097 },
  { name: 'İncesu', slug: 'incesu', population: 24555 },
  { name: 'Avanos', slug: 'avanos-alt', population: 35145 },
  { name: 'Hacıbektaş', slug: 'hacibektas', population: 13082 },
  { name: 'Kozaklı', slug: 'kozakli', population: 7947 },
  { name: 'Gülşehir', slug: 'gulsehir', population: 24618 },
  { name: 'Derinkuyu', slug: 'derinkuyu', population: 10679 },
  { name: 'Kaymaklı', slug: 'kaymakli', population: 2500 },
  { name: 'Mustafapaşa', slug: 'mustafapasa', population: 1695 },
  { name: 'Ortahisar', slug: 'ortahisar', population: 2029 },
  { name: 'Çavuşin', slug: 'cavusin', population: 500 },
  { name: 'Pamukkale', slug: 'pamukkale', population: 2600 },
  { name: 'Hierapolis', slug: 'hierapolis', population: 0 },
  { name: 'Laodicea', slug: 'laodicea', population: 0 },
  { name: 'Aphrodisias', slug: 'aphrodisias', population: 0 },
  { name: 'Priene', slug: 'priene', population: 0 },
  { name: 'Miletus', slug: 'miletus', population: 0 },
  { name: 'Didyma', slug: 'didyma', population: 0 }
];

export const turkeyExpanded = {
  code: 'TR',
  name: 'Turkey',
  slug: 'turkey',
  population: 84339067,
  topCities: turkeyAdditionalCities
};
